import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ClosePageButtonSVG from '../../assets/svg-icons/ClosePageButton.inline.svg';
import {SVGIcon} from '../ui/SVGIcon/SVGIcon';
import styles from './ClosePageButton.scss';

export const ClosePageButton = ({className, iconClassName, onClick, accName}) => {
  return (
    <button
      className={classnames([styles.closePageButton, className])}
      aria-label={accName}
      onClick={onClick}
      data-hook="close-page-button"
    >
      <SVGIcon Svg={ClosePageButtonSVG} className={classnames(styles.closePageButtonIcon, iconClassName)} />
    </button>
  );
};

ClosePageButton.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  accName: PropTypes.string.isRequired,
};
